import { observer, useObserver } from "mobx-react-lite";
import { CommonStore, VideoListStore } from "../../../store";
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Space,
  Table,
  Row,
  Col,
  Modal,
  Select,
  Tooltip,
  Dropdown,
  Menu,
  MenuProps,
  Empty,
  ConfigProvider,
} from "antd";
import UpdateOrAdd from "./update_or_add";
import "./index.css";
import { MoreOutlined } from "@ant-design/icons";
import {
  CloudUploadOutlined,
  DownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import dictionary from "../../../utils/dictionary";

const { Column } = Table;

function VideoList() {
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    // searchBtn();
    form.setFieldsValue({ name: "", videoStatus: null, videoTag: null });
    resetSearchbth();
    // CommonStore.getPagePermission("user_group");
  }, []);
  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    VideoListStore.setSearchForm({ ...allValues });
  };
  const searchBtn = () => {
    VideoListStore.resetPage();
    VideoListStore.getVideoPage();
  };
  const resetSearchbth = () => {
    VideoListStore.setSearchForm({});
    searchBtn();
  };

  const addPower = (data: string, record?: any) => {
    if (data === "upload") {
      VideoListStore.addOrUpdateModal.open("upload");
    } else if (data === "message") {
      VideoListStore.addOrUpdateModal.open("message");
    } else if (data === "update") {
      VideoListStore.addOrUpdateModal.open("update", record);
    }else if (data === "uploadTest") {
      VideoListStore.addOrUpdateModal.open("uploadTest");
    }
  };

  const moreOperationsClick = (e: any, record: any) => {
    if (e.key === "1") {
      return VideoListStore.downloadVideo(record.no);
    } else if (e.key === "2") {
      console.log(record);

      return VideoListStore.changeOperate(record);
    } else if (e.key === "3") {
      return VideoListStore.deletePower(record.no);
      // return UserGroupStore.changeIsEnable(record.isEnable, record.no)
    }
  };
  const moreOperations = (record: any) => {
    return [
      {
        key: "1",
        label: "下载视频",
        style: { display: CommonStore.pagePermission.writable ? "" : "none" },
      },
      {
        label: record.videoStatus === 2 ? "上架视频" : "下架视频",
        key: "2",
        style: {
          color: record.isEnable ? "red" : "",
          display:
            CommonStore.pagePermission.writable &&
            (record.videoStatus === 1 || record.videoStatus === 2)
              ? ""
              : "none",
        },
      },
      {
        label: "删除视频",
        key: "3",
        style: {
          color: "red",
          display:
            CommonStore.pagePermission.writable &&
            (record.videoStatus === 1 ||
              record.videoStatus === 2 ||
              record.videoStatus === 4)
              ? ""
              : "none",
        },
      },
    ];
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log(e.key);
    if (e.key === "1") {
      return addPower("upload");
    }
    if (e.key === "2") {
      return addPower("uploadTest");
    }
    // else if (e.key === "2"){
    //   console.log('挂机短信');
    //   return addPower('message');
    // }
  };
  const items = [
    {
      label: "视频上传",
      key: "1",
      style: { display: CommonStore.pagePermission.writable ? "" : "none" },
    },
    {
      label: "视频上传test",
      key: "2",
      style: { display: window.location.href.indexOf('?test') > 0 &&CommonStore.pagePermission.writable ? "" : "none" },
    },
    // {
    //   label: "挂机短信",
    //   key: "2",
    //   style: { display: CommonStore.pagePermission.manageable ? '':'none' },
    // },
  ];

  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <UpdateOrAdd></UpdateOrAdd>
      <div className="formContent">
        <Form
          form={form}
          initialValues={VideoListStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <Form.Item label="视频名称" name="name">
                <Input placeholder="请输入视频名称" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="视频状态" name="videoStatus">
                <Select placeholder="请选择视频状态">
                  {Object.keys(dictionary.videoStatus).map((key) => (
                    <Option key={key} value={key}>
                      {dictionary.videoStatus[key]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="视频标签" name="videoTag">
                <Select placeholder="请选择视频标签">
                  {Object.keys(dictionary.videoTag).map((key) => (
                    <Option key={key} value={dictionary.videoTag[key]}>
                      {dictionary.videoTag[key]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col offset={2}>
              <Space>
                <Button type="primary" onClick={searchBtn}>
                  搜索
                </Button>
                <Button htmlType="reset" onClick={resetSearchbth}>
                  重置
                </Button>
              </Space>
            </Col>
          </Row>
          <Row>
            {(CommonStore.pagePermission.writable ||
              CommonStore.pagePermission.manageable) && (
              <Col span={8} offset={16} style={{ marginBottom: "10px" }}>
                <Dropdown
                  dropdownRender={(menu) => (
                    <Menu onClick={handleMenuClick} items={items} />
                  )}
                >
                  <Button style={{ float: "right" }}>
                    <Space className="change">
                      变更
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Col>
            )}
          </Row>
        </Form>
      </div>
      <ConfigProvider renderEmpty={tableEmptyRender}>
        <Table
          dataSource={VideoListStore.tableData.records}
          rowKey={(record: { no: string }) => record.no}
          loading={VideoListStore.tableLoad}
          scroll={{ x: 1200 }}
          pagination={{
            current: VideoListStore.pageData.page,
            pageSize: VideoListStore.pageData.size,
            onChange: VideoListStore.pageData.changePage,
            pageSizeOptions: [10, 25, 50],
            showSizeChanger: true,
            total: VideoListStore.tableData.total,
            showTotal: () => `共计${VideoListStore.tableData.total}条`,
            position: ["bottomLeft"],
          }}
        >
          <Column
            title="视频名称"
            width={150}
            ellipsis={true}
            dataIndex="name"
            render={(name) => (
              <Tooltip placement="topLeft" title={name}>{name}</Tooltip>
            )}
          />
          <Column
            width={150}
            ellipsis={true}
            title="视频状态"
            dataIndex="videoStatus"
            render={(videoStatus) => dictionary.videoStatus[videoStatus]}
          />
          <Column
            width={150}
            ellipsis={true}
            title="视频标签"
            dataIndex="videoTag"
          />
          <Column
            width={150}
            ellipsis={true}
            title="UUID"
            dataIndex="videoUuId"
            render={(videoUuId) => (
              <Tooltip placement="topLeft" title={videoUuId}>
                {videoUuId}
              </Tooltip>
            )}
          />

          <Column
            width={200}
            ellipsis={true}
            title="创建时间"
            dataIndex="createTime"
          />
          <Column
            width={200}
            ellipsis={true}
            title="更新时间"
            dataIndex="updateTime"
          />
          <Column
            width={150}
            ellipsis={true}
            title="审核意见"
            dataIndex="openFailedMsg"
          />
          <Column
            width={120}
            fixed={"right"}
            render={(text: string, record: any) => (
              <Space>
                {CommonStore.pagePermission.writable && (
                  <Button
                    size={"small"}
                    onClick={() => addPower("update", record)}
                  >
                    编辑
                  </Button>
                )}
                {CommonStore.pagePermission.writable && (
                  <Dropdown
                    dropdownRender={() => (
                      <Menu
                        onClick={(e) => moreOperationsClick(e, record)}
                        className={"menuSty"}
                        items={moreOperations(record)}
                      />
                    )}
                  >
                    <Button size={"small"}>
                      <MoreOutlined />
                    </Button>
                  </Dropdown>
                )}
              </Space>
            )}
          />
        </Table>
      </ConfigProvider>
    </Fragment>
  );
}

export default observer(VideoList);
